var _defs, _path, _rect, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-8);}.cls-3{fill:url(#linear-gradient-9);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-6);}.cls-6{fill:url(#linear-gradient-7);}.cls-7{fill:url(#linear-gradient-4);}.cls-7,.cls-8,.cls-9{opacity:.5;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.964,
    y1: 25,
    x2: 29.75,
    y2: 25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6cbcc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 21.776,
    y1: 0.794,
    x2: 25.232,
    y2: 5.776,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 17.848,
    y1: 19,
    x2: 23,
    y2: 19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fa5a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 18,
    y1: 9,
    y2: 9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 18,
    y1: 14,
    y2: 14,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 10.25,
    y1: 35.5,
    x2: 38.795,
    y2: 35.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fc6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50a7f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 28.879,
    y1: 35.879,
    x2: 33.121,
    y2: 40.121,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90d5fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 21.586,
    y1: 29.586,
    x2: 24.414,
    y2: 32.414,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 14.586,
    y1: 35.586,
    x2: 17.414,
    y2: 38.414,
    xlinkHref: "#linear-gradient-7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,4v14.965c0,.936,.328,1.843,.928,2.562l8.389,10.058c2.237,2.682,2.673,6.434,1.111,9.558h0c-1.488,2.977-4.531,4.857-7.859,4.857H15.431c-3.328,0-6.371-1.88-7.859-4.857h0c-1.562-3.124-1.126-6.876,1.111-9.558l8.389-10.058c.6-.719,.928-1.626,.928-2.562V4h12Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16,
    y: 2,
    width: 16,
    height: 4,
    rx: 2,
    ry: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23,19c0,.552-.448,1-1,1h-4.152c.091-.337,.152-.682,.152-1.036v-.964h4c.552,0,1,.448,1,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18,10h4c.552,0,1-.448,1-1s-.448-1-1-1h-4v2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18,15h4c.552,0,1-.448,1-1s-.448-1-1-1h-4v2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.683,31.585c-2.237,2.682-2.673,6.434-1.111,9.558,1.488,2.977,4.531,4.857,7.859,4.857h17.139c3.328,0,6.371-1.88,7.859-4.857,1.562-3.124,1.126-6.876-1.111-9.558l-5.492-6.585H14.175l-5.492,6.585Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 31,
    cy: 38,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23,
    cy: 31,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16,
    cy: 37,
    r: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLab);
export default __webpack_public_path__ + "static/media/ic_lab.14eb790f04837f10b6ebc7eb54f99525.svg";
export { ForwardRef as ReactComponent };